// Display labels for membership tiers. Backend keys are intentionally unchanged
// (standard/pro/premium/business) to avoid breaking paygate logic; only the
// user-facing labels were renamed per product.
export const TIER_LABELS = {
  standard: "VIP",
  pro: "PRO",
  premium: "CAPITAL",
  business: "TEAMS",
};

export function tierLabel(tier) {
  if (!tier) return "—";
  return TIER_LABELS[tier] || tier.toUpperCase();
}

// Ordering ladder (matches backend services/entitlements.py TIER_ORDER). Used to
// decide Upgrade vs Downgrade vs Current on the in-dashboard Plans page.
export const TIER_ORDER = { standard: 0, pro: 1, premium: 2, business: 3 };
